module.exports = __webpack_public_path__ + "static/media/lv-star.69809880.svg";